import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import {
  FOOTER_PRODUCT_LINKS,
  HEADER_CTA,
  HEADER_LINKS,
} from '@/features/home/constants/home.constants';
import type { SiteLink } from '@/types/home.types';

interface UsePublicLayoutResult {
  headerLinks: SiteLink[];
  headerCta: SiteLink;
  footerProductLinks: SiteLink[];
  isMenuOpen: boolean;
  onToggleMenu: () => void;
  onCloseMenu: () => void;
  year: number;
}

export const usePublicLayout = (): UsePublicLayoutResult => {
  const { pathname, hash } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onToggleMenu = useCallback(() => setIsMenuOpen((open) => !open), []);
  const onCloseMenu = useCallback(() => setIsMenuOpen(false), []);

  // An in-page anchor doesn't unmount the drawer, so close it on every move.
  useEffect(() => setIsMenuOpen(false), [pathname, hash]);

  return {
    headerLinks: HEADER_LINKS,
    headerCta: HEADER_CTA,
    footerProductLinks: FOOTER_PRODUCT_LINKS,
    isMenuOpen,
    onToggleMenu,
    onCloseMenu,
    year: new Date().getFullYear(),
  };
};
